import React from "react";
import DatePicker from "react-date-picker";
import styles from "./datepicker.module.css";
import "./picker.css";
import { styled } from "@mui/material/styles";

export default function CustomDatePicker(props) {
  const calendarClassName = styles["date-picker-calendar-container"];

  return (
    <StyledDatePicker
      format="MM/dd/yyyy"
      {...props}
      calendarClassName={calendarClassName}
    />
  );
}

const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
  display: "flex",
  height: "40px",
  alignItems: "center",
  border: "none !important",
  borderRadius: "12px",
  backgroundColor: "var(--Base-24, #F4F4F4)",
  fontFamily: "CircularStd",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal",
  color: "var(--Base-1000, #000)",
  outline: "none !important",
  boxShadow: "none !important",
  cursor: "pointer",

  "& .react-date-picker__wrapper": {
    border: "none !important",
    backgroundColor: "var(--Base-24, #F4F4F4)",
    borderRadius: "12px",
    padding: "10px",
  },

  "&:focus, &:active, &:hover": {
    border: "none !important",
    outline: "none !important",
    boxShadow: "none !important",
  },

  "& .react-date-picker__inputGroup__input": {
    color: "var(--Base-1000, #000)",
    fontFamily: "CircularStd",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
    border: "none !important",
    outline: "none !important",
    backgroundColor: "transparent",
  },

}));
